<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopHouse.queryCondition') }}</div>
      </div>
      <div class="">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input v-model="shopHouseManageInfo.conditions.shId" :placeholder="$t('shopHouse.inputShId')"
              clearable />
          </el-col>
          <el-col :span="4">
            <el-input v-model="shopHouseManageInfo.conditions.shName" :placeholder="$t('shopHouse.inputShName')"
              clearable />
          </el-col>
          <el-col :span="4">
            <el-select v-model="shopHouseManageInfo.conditions.shType" :placeholder="$t('shopHouse.selectShType')"
              style="width:100%" clearable>
              <el-option v-for="item in shopHouseManageInfo.shTypes" :key="item.statusCd" :label="item.name"
                :value="item.statusCd" />
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="_queryShopHouseMethod">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button @click="_resetShopHouseMethod">
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopHouse.shopHouseInfo') }}</div>
        <el-button type="primary" @click="_openAddShopHouseModal">
          <i class="el-icon-plus"></i> {{ $t('common.add') }}
        </el-button>
      </div>
      <div class="">
        <el-table :data="shopHouseManageInfo.shopHouses" border style="width: 100%">
          <el-table-column prop="shId" :label="$t('shopHouse.shId')" align="center" />
          <el-table-column prop="shName" :label="$t('shopHouse.shName')" align="center" />
          <el-table-column prop="shType" :label="$t('shopHouse.shType')" align="center">
            <template #default="{ row }">
              {{ row.shType === '2807' ? $t('shopHouse.normalWarehouse') : $t('shopHouse.mainWarehouse') }}
            </template>
          </el-table-column>
          <el-table-column prop="shDesc" :label="$t('shopHouse.shDesc')" align="center" />
          <el-table-column prop="createTime" :label="$t('shopHouse.createTime')" align="center" />
          <el-table-column :label="$t('common.operation')" align="center" width="180">
            <template #default="{ row }">
              <el-button size="mini" @click="_openEditShopHouseModel(row)">{{ $t('common.edit') }}</el-button>
              <el-button size="mini" type="danger" @click="_openDeleteShopHouseModel(row)">{{ $t('common.delete')
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page.sync="shopHouseManageInfo.conditions.page"
          :page-size="shopHouseManageInfo.conditions.row" layout="total, prev, pager, next"
          :total="shopHouseManageInfo.total" />
      </div>
    </el-card>

    <add-shop-house ref="addShopHouse" @refresh="_listShopHouses" />
    <edit-shop-house ref="editShopHouse" @refresh="_listShopHouses" />
    <delete-shop-house ref="deleteShopHouse" @refresh="_listShopHouses" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { queryShopHouse } from '@/api/goods/shopHouseApi'
import AddShopHouse from '@/components/goods/addShopHouse/addShopHouse.vue'
import EditShopHouse from '@/components/goods/editShopHouse/editShopHouse.vue'
import DeleteShopHouse from '@/components/goods/deleteShopHouse/deleteShopHouse.vue'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopHouseManage',
  components: {
    AddShopHouse,
    EditShopHouse,
    DeleteShopHouse
  },
  data() {
    return {
      shopHouseManageInfo: {
        shopHouses: [],
        total: 0,
        records: 1,
        moreCondition: false,
        shTypes: [],
        conditions: {
          shName: '',
          shId: '',
          shType: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      let shopId = await getShopId()
      this.shopHouseManageInfo.conditions.shopId = shopId
      await this._listShopHouses()
      this._getDictData()
    },
    async _getDictData() {
      try {
        const { data } = await getDict('s_shop_house', 'sh_type')
        this.shopHouseManageInfo.shTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listShopHouses(page = 1, rows = 10) {
      this.shopHouseManageInfo.conditions.page = page
      this.shopHouseManageInfo.conditions.row = rows
      try {
        const res = await queryShopHouse(this.shopHouseManageInfo.conditions)
        this.shopHouseManageInfo.shopHouses = res.data
        this.shopHouseManageInfo.total = res.total
        this.shopHouseManageInfo.records = res.records
      } catch (error) {
        console.error('获取仓库列表失败:', error)
      }
    },
    _openAddShopHouseModal() {
      this.$refs.addShopHouse.open()
    },
    _openEditShopHouseModel(row) {
      this.$refs.editShopHouse.open(row)
    },
    _openDeleteShopHouseModel(row) {
      this.$refs.deleteShopHouse.open(row)
    },
    _queryShopHouseMethod() {
      this._listShopHouses()
    },
    _resetShopHouseMethod() {
      this.shopHouseManageInfo.conditions = {
        ...this.shopHouseManageInfo.conditions,
        shName: '',
        shId: '',
        shType: '',
        page: 1,
        row: 10
      }
      this._listShopHouses()
    },
    handleCurrentChange(val) {
      this._listShopHouses(val, this.shopHouseManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.ibox-title {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ibox-content {
  padding: 20px;
}
</style>